import { composeSelectors } from "seneca-common/utils/selectors/compose-selectors";

import QuestionAggregation from "../../../../../models/QuestionsAggregation";
import * as questions from "./questions";

type State = QuestionAggregation;

export function getQuestionsAverageMark(state: State) {
  return state.get("averageMark");
}

export function getQuestionsMarksTotal(state: State) {
  return state.get("marksTotal");
}

export function getQuestionAggregates(state: State) {
  return state.get("questions");
}

export const { getAverageMark, getMarksTotal } = composeSelectors(
  getQuestionAggregates as any,
  questions
);
